import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle, FaBirthdayCake, FaUserFriends, FaStar, FaRegHeart, FaHeart } from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";
import { CiCalendar } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { ReviewModal } from "../components/review_modal";


export default function History() {
    const navigate = useNavigate();
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [bookingList, setBookingList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [offset, setOffset] = useState(0);
    const [pagination, setPagination] = useState('');
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [showReviewModal, setShowReviewModal] = useState(false);
    const [apartmentReview, setApartmentReview] = useState({});

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [])

    useEffect(() => {
        getData();
    }, [offset])

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

    async function getData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('offset', offset);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/booking-history.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.bookings);
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {showReviewModal &&
            <ReviewModal 
                setShowReviewModal={setShowReviewModal}
                apartment={apartmentReview}
                getData={getData}
                setApartmentReview={setApartmentReview}
            />
      }
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#037684'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, ${cookies?.userProfile?.name}`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <h2 className="text-xl md:text-2xl text-black font-bold">{'Booking History'}</h2>
            <div className='overflow-x-auto mt-5'>
                <table className="w-full table-auto border-collapse text-sm md:text-[15px]">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="hidden md:table-cell px-2 py-4">
                            <div className="flex items-center gap-1">#</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Apartment(s)</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Check In</div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Check Out</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Duration</div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Status</div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Booking Time</div>
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {bookingList?.map((row, index) => (
                            <tr
                            key={index}
                            className={index % 2 === 0 ? "bg-white animate-fadeIn" : "bg-gray-50 animate-fadeIn"}
                            >
                                <td className="hidden md:table-cell px-2 py-2">
                                    {++index}
                                </td>
                                <td className="px-2 py-2 font-semibold">
                                    <span className="flex flex-row items-end">{row.apt_cat}{row.apartments_booked > 1 && <p className="text-[#585858] text-xs ml-1">{' +'}{row.apartments_booked-1} apts.</p>}</span>
                                </td>
                                <td className="px-2 py-2">
                                    {row.check_in}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.check_out}
                                </td>
                                <td className="px-2 py-2">
                                    {row.duration} Night(s)
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.status ?
                                    <div className="px-2 py-1 rounded-[5px] border border-1 border-[#00b47a] bg-[#defff4] text-[#00b47a] font-semibold text-center text-xs">{'Paid'}</div>
                                    :
                                    <div className="px-2 py-1 rounded-[5px] border border-1 border-[#ff0000] bg-[#ffe3e7] text-[#ff0000] font-semibold text-center text-xs">{'Cancelled'}</div>
                                    } 
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.time }
                                </td>
                                <td className="px-2 py-2">
                                    <div className="flex flex-col md:flex-row gap-y-1 md:gap-y-0 gap-x-1">
                                        <div onClick={() => { setApartmentReview({ name: row.apt_name, apartment_id: row.apt_id, booking_reference: row.rrr }); setShowReviewModal(true);  }} className="flex items-center justify-center gap-x-1 cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-primary bg-white text-primary font-semibold text-center mr-2">{row.guest_rating != "" && row.guest_rating}{row.guest_rating == "" ? <FaRegHeart size={17} color="#ff0044" /> : <FaHeart size={17} color="#ff0044" /> }</div>
                                        <div onClick={() => navigate(`/dashboard/home`, { state: {apt: row.apt_id, apt_name: row.apt_name}} )} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-primary bg-white text-primary font-semibold text-center text-xs">{'Rebook'}</div>
                                        <div onClick={() => navigate(`/dashboard/reservation-success/${row.rrr}`)} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-primary bg-primary text-white font-semibold text-center text-xs">{'View'}</div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='w-full flex justify-end mt-6'>
                <div className='flex flex-col items-center'>
                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-1 py-1 w-fit bg-white">
                        <button
                            onClick={() => changePage('prev')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Prev.
                        </button>
                        <button
                            onClick={() => changePage('next')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Next
                        </button>
                    </div> 
                    <label className='text-sm mt-2'>{pagination}</label>
                </div>
            </div>
        </div>
    </div>
  );
}
